import { ApolloError } from '@apollo/client';

import { getErrorWithExtensionInfo } from '@ocx/apollo-client';
import { getDevicePlatform } from '@ocx/utils-device';
import { OtpPlatform } from '@ocx/graphql';

import { OC_CUSTOMER_BLOCKED_ERROR, OC_CUSTOMER_PHONE_NUMBER_INACTIVE_ERROR } from './signup.constants';

export const getIsPhoneNumberBlocked = (error: unknown) => {
  if (
    error instanceof ApolloError &&
    getErrorWithExtensionInfo(error.graphQLErrors)?.extensionCode === OC_CUSTOMER_BLOCKED_ERROR
  ) {
    return true;
  }

  return false;
};

export const getIsPhoneNumberInactive = (error: unknown) => {
  if (
    error instanceof ApolloError &&
    getErrorWithExtensionInfo(error.graphQLErrors)?.extensionCode === OC_CUSTOMER_PHONE_NUMBER_INACTIVE_ERROR
  ) {
    return true;
  }

  return false;
};

export const getOTPPlatform = () => {
  const capacitorPlatform = getDevicePlatform();
  if (capacitorPlatform === 'ios') {
    return OtpPlatform.Iphone;
  }
  if (capacitorPlatform === 'android') {
    return OtpPlatform.Android;
  }
  return OtpPlatform.Web;
};
